function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { contextualizeFund, contextualizeProduct, modelizeProduct, modelizeReview, modelizeOrganization, contextualizeStorefront } from '../models';
import { pillsLayers } from './pills';
import { searchLayers } from './search';
import { userLayers } from './user';
import { jumboLayers } from './jumbo';
import { tableLayers } from './table';
import { articlesLayers } from './articles';
import { shareLayers } from './share';
import { questionsLayers } from './questions';
import { profilesLayers } from './profiles';
import { carouselLayers } from './carousel';
import { clearLayers } from './clear';
import { comparisonsLayers } from './comparisons';
import { conversationsLayers } from './conversations';
import { storiesLayers } from './stories';
import { scenesLayers } from './scenes';
export var layers = [].concat(_toConsumableArray(scenesLayers), _toConsumableArray(pillsLayers), _toConsumableArray(searchLayers), _toConsumableArray(userLayers), _toConsumableArray(jumboLayers), _toConsumableArray(tableLayers), _toConsumableArray(articlesLayers), _toConsumableArray(shareLayers), _toConsumableArray(questionsLayers), _toConsumableArray(profilesLayers), _toConsumableArray(carouselLayers), _toConsumableArray(clearLayers), _toConsumableArray(comparisonsLayers), _toConsumableArray(conversationsLayers), _toConsumableArray(storiesLayers), [{
  id: 'Fund',
  type: 'view',
  action: 'product',
  name: 'product',
  sendEvent: true,
  contextualize: function contextualize(_ref) {
    var fund = _ref.fund;
    return contextualizeFund(fund);
  }
}, {
  id: 'SectionExpand',
  type: 'click',
  action: 'sectionExpandOpen',
  name: 'section',
  model: 'section',
  event: true,
  modelize: function modelize(params) {
    return params;
  }
}, {
  id: 'Product',
  type: 'view',
  action: 'product',
  name: 'product',
  sendEvent: true,
  contextualize: function contextualize(_ref2) {
    var product = _ref2.product;
    return contextualizeProduct(product);
  }
}, {
  id: 'Reviews',
  type: 'impressions',
  name: 'reviews',
  modelize: function modelize(_ref3) {
    var models = _ref3.models;
    return models.map(modelizeReview);
  }
}, {
  id: 'Scene',
  type: 'pageType',
  modelize: function modelize(params) {
    return params;
  }
}, {
  id: 'Storefront',
  type: 'view',
  action: 'storefront',
  name: 'storefront',
  sendEvent: true,
  contextualize: function contextualize(_ref4) {
    var tag = _ref4.tag;
    return contextualizeStorefront(tag);
  }
}, {
  id: 'ContentProductsCarousel',
  type: 'impressions',
  name: 'ecommerce',
  model: 'product',
  modelize: function modelize(_ref5) {
    var models = _ref5.models,
      tag = _ref5.tag;
    return models.map(function (model, index) {
      var featuring = model.entity.metadata.find(function (_ref6) {
        var meta = _ref6.meta;
        return meta === 'winning';
      }) ? 'winning' : tag && tag.sponsorship.window && tag.sponsorship.window.product && model.entity.id === tag.sponsorship.window.product ? 'sponsored' : null;
      return _objectSpread(_objectSpread(_objectSpread({}, modelizeProduct(model)), {
        position: index,
        featuring: featuring
      }), tag ? {
        list: tag.name
      } : {});
    });
  }
}, {
  id: 'ProductCard',
  type: 'productClick',
  action: 'click',
  name: 'ecommerce',
  model: 'product',
  event: true,
  modelize: function modelize(_ref7) {
    var product = _ref7.product,
      position = _ref7.position,
      element = _ref7.element;
    return [_objectSpread(_objectSpread(_objectSpread({}, modelizeProduct(product)), {
      position: position
    }), {
      clickOn: element ? element : null
    })];
  }
}, {
  id: 'ProductLeads',
  type: 'addToCart',
  action: 'add',
  name: 'ecommerce',
  model: 'product',
  event: true,
  modelize: function modelize(_ref8) {
    var model = _ref8.model,
      commercialization = _ref8.commercialization;
    return [_objectSpread(_objectSpread({}, modelizeProduct(model)), {
      distributor: commercialization ? modelizeOrganization(commercialization.organization) : null
    })];
  }
}, {
  id: 'Tabs',
  type: 'change',
  action: 'onChangeTab',
  model: 'tab',
  name: 'tab',
  event: true,
  modelize: function modelize(params) {
    return params;
  }
}, {
  id: 'FiEvent',
  type: 'fiEvent',
  action: 'event',
  model: 'fiEvent',
  name: 'fiEvent',
  event: true,
  modelize: function modelize(params) {
    return params;
  }
}, {
  id: 'Impression',
  type: 'fiEvent',
  action: 'event',
  model: 'fiEvent',
  name: 'fiEvent',
  event: true,
  modelize: function modelize(params) {
    return params;
  }
}]);